import React from 'react'
import { Document, Page, Text, View, StyleSheet, Font,  Image } from '@react-pdf/renderer';
import { calcularEdad } from '../../../hooks/UseDate';
import logo from '../../../images/CCE.jpeg'



// Registro de fuente personalizada
Font.register({
    family: 'Open Sans',
    fonts: [
      { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
      { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
    ]
  })

 

  const styles = StyleSheet.create({
    page: {
      padding: 30,
    },
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    column: {
      width: '50%',      
      fontSize: 10
    },
    bold:{
      fontFamily: 'Open Sans',
      fontWeight: 600
    },
    table: { 
      display: "table", 
      width: "auto", 
      borderStyle: "none",      
    }, 
    tableRow: {       
      flexDirection: "row" 
    }, 
    
    tableCell: { 
      width: "12.5%",
      padding: '3px',      
      fontSize: 8 
    },
    
    tableCellLarge:{
      width: "50%",
      padding: '3px',      
      fontSize: 8 
    },
    
    
    tableCellOtrosParticipantes: { 
      width: "25%",
      padding: '3px',      
      fontSize: 8 
    },
    columnMedico:{
      width: '50%',      
      fontSize: 8
    },
    textBox: {
      padding: 10,
      backgroundColor: '#e0e0e0',  // color gris
      fontSize: 9,
      marginTop: 3, // Agregar margen en la parte superior de la fila
      marginBottom: 3, // Agregar margen en la parte inferior de la fila
    },
    image: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 60, 
      height: 60, 
      margin: '40px',
    },

    
  });
  
  //funciona
  // const styles = StyleSheet.create({
  //     title: { fontFamily: 'Open Sans', fontSize: 9, fontWeight: 900 }, // doesn't work without fontFamily
  //     texto: { fontFamily: 'Open Sans', fontSize: 9,  }, 
  // })
const PDFDescripcionQuirurgica = ({dataDescripcionQx,dataOtrosParticipantes,dataPreoperatorio,dataPostOperatorio,dataProcedimientosQx,seleccionarMedico,dataDescripcionQxCirujanos}) => {
   

 
  return (
    <Document>
      <Page size="A4" style={styles.page}>
      <Image style={styles.image} src={logo} />
        <Text style={{ fontSize: 10,textAlign: 'center',fontFamily: 'Open Sans',fontWeight: 900}}>{dataDescripcionQx.EmpRazSoc? dataDescripcionQx.EmpRazSoc.trim():null}</Text>   
        <Text style={{ fontSize: 10,textAlign: 'center',fontFamily: 'Open Sans',fontWeight: 900}}>{dataDescripcionQx.MCDnom? dataDescripcionQx.MCDnom.trim():null}</Text>
        <Text style={{ fontSize: 10,textAlign: 'center',fontFamily: 'Open Sans',fontWeight: 900}}>{dataDescripcionQx.EmpNit? dataDescripcionQx.EmpNit.trim():null}</Text> 
        <Text style={{ fontSize: 10,textAlign: 'center',fontFamily: 'Open Sans',fontWeight: 900}}>{dataDescripcionQx.MDNomM? dataDescripcionQx.MDNomM.trim():null} - {dataDescripcionQx.MDNomD? dataDescripcionQx.MDNomD.trim():null}</Text>
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>DESCRIPCIÓN DE CIRUGÍAS</Text> 
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, }}/>
        <View style={styles.container}>
          <View style={styles.column}>
            <Text><Text style={styles.bold}>Paciente:</Text> {dataDescripcionQx.MPNOMC?dataDescripcionQx.MPNOMC.trim():null}</Text>
            <Text><Text style={styles.bold}>Edad:</Text> {dataDescripcionQx.MPFchN?calcularEdad(dataDescripcionQx.MPFchN.split(" ")[0] ):null} Años</Text>
            <Text><Text style={styles.bold}>Sala:</Text> {dataDescripcionQx.ProNcons? dataDescripcionQx.ProNcons.trim():null}</Text>            
          </View>
          <View style={styles.column}>
            <Text><Text style={styles.bold}>Identificación:</Text> {dataDescripcionQx.MPTDoc}-{dataDescripcionQx.MPCedu? dataDescripcionQx.MPCedu.trim():null}</Text>
            <Text><Text style={styles.bold}>Empresa:</Text> {dataDescripcionQx.ProNEPS?dataDescripcionQx.ProNEPS.trim():null}</Text>
            <Text><Text style={styles.bold}>Fecha programación de cirugía:</Text> {dataDescripcionQx.ProFec? dataDescripcionQx.ProFec.split(' ')[0]:null}</Text>
          </View>          
        </View>
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5,  marginTop:5}}/>
        <View style={styles.container}>
          <View style={styles.column}>
            <Text><Text style={styles.bold}>Sede de Atención:</Text> {dataDescripcionQx.MCDnom?dataDescripcionQx.MCDnom.trim():null}</Text>
                                     
          </View>
          <View style={styles.column}>
            
          </View>          
        </View>
        <Text style={styles.textBox}><Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900,textAlign: 'center'}}>CIRUGÍAS</Text></Text>
        <View  style={styles.table}>
                <View style={styles.tableRow}>
                    <View style={styles.tableCell}>
                        <Text  style={styles.bold}>CÓDIGO</Text> 
                    </View>
                    <View style={styles.tableCellLarge}> 
                        <Text  style={styles.bold}>NOMBRE DE LA CIRUGÍA</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>CANTIDAD </Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>GRUPO QUIRÚRGICO</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>UVR</Text> 
                  </View>
                </View>
                 { 
                     dataProcedimientosQx.map((item,index)=>( 
                        <>
                        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
                        <View style={styles.tableRow} key={index} >
                            <View style={styles.tableCell}> 
                                <Text >{item.CrgCod}</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >{item.CrgDes? item.CrgDes.trim():null }</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{item.CrgCnt}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{item.ForLiqCod}</Text> 
                            </View>     
                            <View style={styles.tableCell}> 
                                <Text >{item.PTCntUvr?item.PTCntUvr:null}</Text> 
                            </View>                          
                        </View>
                        <View style={styles.container}>
                          <View style={styles.columnMedico}>
                          <Text><Text style={styles.bold}>Cirujano:</Text> {item.MedNom?item.MedNom.trim():null}</Text>
                          <Text><Text style={styles.bold}>Vía:</Text> {item.ViaDsc?item.ViaDsc.trim():null}</Text>
                          </View>
                          <View style={styles.columnMedico}>
                          <Text><Text style={styles.bold}>Especialidad:</Text> {item.EspcDes?item.EspcDes.trim():null}</Text>
                          </View>
                          
                        </View>
                        </>
                     )) 
                 } 
        </View>
            <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
            <Text style={styles.textBox}><Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900,textAlign: 'center'}}>DESCRIPCIÓN CIRUGÍA</Text></Text>
            <View style={styles.container}>
              <View style={styles.column}>
                 <Text><Text style={styles.bold}>Cirujano:</Text>  {dataDescripcionQx.MMNomM?dataDescripcionQx.MMNomM.trim():null}</Text>
                <Text><Text style={styles.bold}>Via:</Text>  {dataDescripcionQx.ViaIng? (dataDescripcionQx.ViaIng === 'D'? 'Diferente via':(dataDescripcionQx.ViaIng === 'U'? 'Unica via': 'Bilateral') ) :null}</Text>
                <Text><Text style={styles.bold}>Tipo de Cirugía:</Text>  {dataDescripcionQx.ProSit? (dataDescripcionQx.ProSit === '1'? 'Programada':(dataDescripcionQx.ProSit === '2'?'Urgencias':'Ambulatoria')):null} </Text>                  
                <Text><Text style={styles.bold}>Tiempo de Clamp:</Text> {dataDescripcionQx.TieClamp? `${dataDescripcionQx.TieClamp} Minutos`: null} </Text>  
                <Text><Text style={styles.bold}>Volumen Sangrado:</Text> {dataDescripcionQx.CanSan? `${dataDescripcionQx.CanSan} ml.`:null } </Text>         
              </View>
              <View style={styles.column}>
              <Text><Text style={styles.bold}>Especialidad:</Text>  {dataDescripcionQx.MENomE? dataDescripcionQx.MENomE.trim():null}</Text>
                <Text><Text style={styles.bold}>Tipo de Anestesia:</Text> {dataDescripcionQx.TipAne? (dataDescripcionQx.TipAne === '1'? 'General': (dataDescripcionQx.TipAne === '2'? 'Local':(dataDescripcionQx.TipAne === '3'? 'Epidural': 'Sedación'))):null}</Text>
                
                
                <Text><Text style={styles.bold}>Tiempo de Perfusión:</Text> {dataDescripcionQx.TiePer? `${dataDescripcionQx.TiePer} Minutos` : null} </Text>
                <Text><Text style={styles.bold}>Tipo de Herida:</Text> {dataDescripcionQx.TipHer? (parseInt(dataDescripcionQx.TipHer) === 1? 'Limpia':(parseInt(dataDescripcionQx.TipHer) === 2? 'Limpia contaminada':(parseInt(dataDescripcionQx.TipHer) === 3? 'Contaminada':(parseInt(dataDescripcionQx.TipHer) === 4?'Sucia':null)))):null} </Text>
              </View>          
            </View>
            <View style={styles.container}>
              <View style={styles.column}>
                <Text><Text style={styles.bold}>Clasificación de riesgo quirúrgico:</Text>  </Text>
                <Text><Text style={styles.bold}>Realización Acto Quirúrgico:</Text>  </Text>                          
              </View>
              <View style={styles.column}>
              <Text><Text style={styles.bold}>A.S.A:</Text> </Text>
                <Text><Text style={styles.bold}>Fecha Inicio:</Text> {dataDescripcionQx.FECINICIR? dataDescripcionQx.FECINICIR.split(" ")[0]:null}</Text>
                <Text><Text style={styles.bold}>Hora Inicio:</Text> {dataDescripcionQx.HorIniCir}</Text>                
              </View>         
              <View style={styles.column}>
              <Text><Text style={styles.bold}>NNIS:</Text> {dataDescripcionQx.DesInNNIS}</Text> 
                <Text><Text style={styles.bold}>Fecha Final:</Text>  {dataDescripcionQx.FECINICIR? dataDescripcionQx.FECINICIR.split(" ")[0]:null}</Text>
                <Text><Text style={styles.bold}>Hora Final:</Text>  {dataDescripcionQx.HorFinCir}</Text>                
              </View>       
            </View>
            <Text style={{ fontSize: 10,}}><Text style={styles.bold}>Dx Preoperatorio:</Text>  {dataPreoperatorio.map((itemP,index)=>(<Text key={index}>{itemP.DMCodi}-{itemP.DMNomb?itemP.DMNomb.trim():null}</Text>))}</Text>
            <Text style={{ fontSize: 10,}}><Text style={styles.bold}>Dx Postoperatorio:</Text>  {dataPostOperatorio.map((itemP,index)=>(<Text key={index}>{itemP.DMCodi}-{itemP.DMNomb? itemP.DMNomb.trim():null}</Text>))}</Text>
            {/* <Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900}}> Descripcion Quirúrgica:</Text> */}
            {/* <Text style={{ fontSize: 8,}}>{dataDescripcionQx.DesCir}</Text> */}
            <Text style={{ fontSize: 10,}}><Text style={styles.bold}>Complicaciones:</Text>  {dataDescripcionQx.DesIndCom?(dataDescripcionQx.DesIndCom ==='S'? 'SI':'NO'):null}</Text>
            <Text style={{ fontSize: 10,}}><Text style={styles.bold}>Complicaciones presentes en la Cirugía:</Text>  {dataDescripcionQx.DesCom}</Text>
            
            {/* <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/> */}
            {/* <Text style={{ fontSize: 10,}}><Text style={styles.bold}>Hallazgos:</Text>  {dataDescripcionQx.DesHalEnc}</Text> */}
            {/* <Text style={{ fontSize: 10,}}><Text style={styles.bold}>Tejidos enviados a patología:</Text>  </Text> */}
            {/* {
              seleccionarMedico.cantidadCirujanos === 2?
              <View>
                <Text style={{marginTop:15}}></Text>
                <Text style={styles.textBox}><Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900,textAlign: 'center'}}>DESCRIPCIÓN CIRUGÍA SEGUNDO CIRUJANO</Text></Text>
                <Text style={{ fontSize: 10,paddingTop: '3px'}}><Text style={styles.bold}>Nombre Segundo Cirujano :</Text>  {dataDescripcionQx.NombreCirujanoDos}</Text>
                <Text style={{ fontSize: 10, paddingTop: '3px'}}><Text style={styles.bold}>Especialidad Segundo Cirujano :</Text>  {dataDescripcionQx.EspecialidadCirujanoDos}</Text>
                <Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900}}> Descripcion Quirúrgica Segundo Cirujano:</Text>
                <Text style={{ fontSize: 8,}}>{dataDescripcionQx.DesCir2}</Text>
                <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
                <Text style={{ fontSize: 10,}}><Text style={styles.bold}>Hallazgos Segundo Cirujano :</Text>  {dataDescripcionQx.DesHalEnc2}</Text>
              </View>
              :
              null
            } */}
            {
              dataDescripcionQxCirujanos.map((item,index)=>(
              <View key={index}>
                <Text style={{marginTop:15}}></Text>
                <Text style={styles.textBox}><Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900,textAlign: 'center'}}>DESCRIPCIÓN CIRUGÍA CIRUJANO</Text></Text>
                <Text style={{ fontSize: 10,paddingTop: '3px'}}><Text style={styles.bold}>Nombre  Cirujano :</Text>  {item.MMNomM}</Text>
                <Text style={{ fontSize: 10, paddingTop: '3px'}}><Text style={styles.bold}>Especialidad Cirujano :</Text>  {item.MENomE}</Text>
                <Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900}}> Descripcion Quirúrgica Segundo Cirujano:</Text>
                <Text style={{ fontSize: 8,}}>{item.DescripcionQx}</Text>
                <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
                <Text style={{ fontSize: 10,}}><Text style={styles.bold}>Hallazgos Segundo Cirujano :</Text>  {item.HallazgosQx}</Text>
              </View>
              ))
              
            }
            <Text style={styles.textBox}><Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900,textAlign: 'center'}}>OTROS PARTICIPANTES</Text></Text>
            <View  style={styles.table}>
                <View style={styles.tableRow}>
                    <View style={styles.tableCellOtrosParticipantes}>
                        <Text  style={styles.bold}>CÓDIGO</Text> 
                    </View>
                    <View style={styles.tableCellLarge}> 
                        <Text  style={styles.bold}>NOMBRE</Text> 
                  </View> 
                  <View style={styles.tableCellOtrosParticipantes}> 
                    <Text  style={styles.bold}>TIPO </Text> 
                  </View> 
                  
                </View>
                {
                     dataOtrosParticipantes.map((item,index)=>(
                        <View style={styles.tableRow} key={index}>
                            <View style={styles.tableCellOtrosParticipantes}> 
                                <Text >{item.PersCod}</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >{item.PersNom}</Text>                                 
                            </View> 
                            <View style={styles.tableCellOtrosParticipantes}> 
                                <Text >{item.PersTipDes}</Text> 
                            </View>       
                        </View>                        
                       
                     )) 
                 } 
        </View>
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{dataDescripcionQx.MMNomM?dataDescripcionQx.MMNomM.trim():null}</Text> 
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{dataDescripcionQx.MENomE? dataDescripcionQx.MENomE.trim():null}</Text> 
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>*** FIN DEL REPORTE ***</Text>  
      </Page>
    

   
  </Document>
  )
}

export default PDFDescripcionQuirurgica